import { createContext, useContext, useState } from "react";
type TopbarContextType = {
  title: string;
  backHref?: string;
  setTitle: (title: string) => void;
  setBackHref: (href?: string) => void;
};
const TopbarTitleContext = createContext<TopbarContextType | undefined>(undefined);
export function useTopbarTitle() {
  const context = useContext(TopbarTitleContext);
  if (!context) {
    throw new Error("useTopbarTitle must be used within a TopbarTitleProvider");
  }
  return context;
}
export function TopbarTitleProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [title, setTitle] = useState<string>("");
  const [backHref, setBackHref] = useState<string | undefined>(undefined);
  return <TopbarTitleContext.Provider value={{
    title,
    setTitle,
    backHref,
    setBackHref
  }} data-sentry-element="unknown" data-sentry-component="TopbarTitleProvider" data-sentry-source-file="context.tsx">
      {children}
    </TopbarTitleContext.Provider>;
}